import React from 'react'
import styled from 'styled-components'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'

import { Button } from '../../../buttons'

import { FONTS } from '../../../../constants'

const tabs = [
  { id: 0, type: 'Resource', value: 'Resource' },
  { id: 1, type: 'Other Service', value: 'Other Service' },
  { id: 2, type: 'Licensing/MA', value: 'Licensing/MA' },
  { id: 3, type: 'Hardware/MA', value: 'Hardware/MA' },
  { id: 4, type: 'Other cost', value: 'Other cost' },
]

export const ToggleTabs = (props) => {
  const {
    isEdit,
    canEdit,
    isPresale,
    setIsEdit,
    activeTab,
    setActiveTab,
    clickEdit,
    clickCancel,
  } = props

  const showEdit = !isPresale && canEdit

  return (
    <Root>
      <Wrapper>
        {tabs.map(tab => {
          return (
            <Tab
              key={ tab.id }
              active={ tab.id === activeTab }
              onClick={ () => setActiveTab(tab.id) }
            >
              <span>{tab.type}</span>
            </Tab>
          )
        })}
      </Wrapper>
      { showEdit && !isEdit && (
        <Button
          width='70px'
          height='26px'
          theme='#28a745'
          onClick={ () => setIsEdit(true) }
          icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
        >
          Edit
        </Button>
      )}
      { isEdit && (
        <ButtonWrapper>
          <Button
            width='70px'
            height='26px'
            theme='#28a745'
            onClick={ clickEdit }
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
          >
            Save
          </Button>
          <Button
            width='70px'
            height='26px'
            theme='#6c757d'
            onClick={ clickCancel }
          >
            Cancel
          </Button>
        </ButtonWrapper>
      )}
    </Root>
  )
}

const Root = styled.div`
    width: 100%;
    height: 51px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    background: #FFFFFF;
`

const Wrapper = styled.div`
  display: flex;
`

const ButtonWrapper = styled(Wrapper)`
  div:nth-child(1) {
    margin-right: 12px;
  }
`

const Tab = styled.div`
  min-width: 115px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 30px;
  background: ${p => (p.active ? '#2F80ED' : '#FFFFFF')};
  border: ${p => (p.active ? '1px solid #004AAE' : '1px solid #F1F1F1')};
  cursor: pointer;

  :nth-child(1) {
    border-radius: 4px 0px 0px 4px;
  }

  :nth-last-child(1) {
    border-radius: 0px 4px 4px 0px;
  }

  span {
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: ${p => (p.active ? '#FFFFFF' : '#818181')};
  }

  ${p => !p.active && `
    :hover {
      background: rgba(47, 128, 237, 0.16);
      border: 1px solid #004AAE;

      span { color: #2F80ED; }
    }
  `}

`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/toggle-tabs.js